import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import { Grid, Card } from '@material-ui/core';
import { Modal } from 'antd';
import MainContainer from '../../../components/MainContainer';
import OutOfStockList from '../../../components/AdminOutOfStock/List/OutOfStockListPage';
import UpdateStock from '../../../components/AdminOutOfStock/Update';

@inject(
    'loginStore',
    'stockStore'
)
@observer
class OutOfStockPage extends Component {
    constructor(props) {
        super(props)
        this.state = {
        }
    }

    componentDidMount() {
        this.props.loginStore.authenticateAdmin().then(response => {
          if (!response) {
            this.props.history.push('/admin/login');
          }
        });

        this.props.stockStore.init();
    }

    handleCancel = () => {
        this.props.stockStore.setShowUpdateStockModal(false);
    }

    render() {
        const { showUpdateStockModal } = this.props.stockStore;

        return (
            <MainContainer title='Out of Stock Management' menukey='outofstock'>
                <Modal
                    title='Update Stock'
                    visible={showUpdateStockModal}
                    width={800}
                    footer={null}
                    onCancel={this.handleCancel}
                >
                    <UpdateStock />
                </Modal>

                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Card style={{ height: 980, padding: 20, overflow: 'auto' }}>
                            <OutOfStockList />
                        </Card>
                    </Grid>
                </Grid>
            </MainContainer>
        )
    }
}

export default OutOfStockPage;